import { z } from "@cnx/common";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { zodI18nMap } from "zod-i18n-map";

export const defaultNS = "common";

export const supportedLanguages = [
  "bg",
  "da",
  "de",
  "ee",
  "en",
  "es",
  "fi",
  "fr",
  "it",
  "lt",
  "lv",
  "nl",
  "pl",
  "ro",
  "ru",
  "se",
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLanguages,
    fallbackLng: "en",
    ns: [
      "common",
      "epics",
      "discussions",
      "messages",
      "features",
      "news",
      "roles",
      "shippingManagement",
      "stakeholders",
      "useRights",
      "users",
      "userStories",
      "zod",
      "tripActivity",
      "notifications",
      "stops",
      "terminal",
      "exceptionTypes",
      "exceptionReasons",
      "exceptionCauses",
      "exceptionWaitingReasons",
      "exceptionResponsible",
      "message",
      "exceptions",
      "payrollTypes",
      "workTypes",
      "absenceTypes",
      "payGroups",
    ],
    defaultNS,
    returnNull: false,
    debug: false,
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
  });

z.setErrorMap(zodI18nMap);
export default i18n;
